<div class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1" id="kt_login">
    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
        <!--begin::Aside-->
        <div class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside">
            <div class="kt-grid__item">
                <a routerLink="/" class="kt-login__logo">
                    <img src="./assets/media/logos/logo-ankuni.png" alt="" />
                </a>
            </div>
            <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
                <div class="kt-grid__item kt-grid__item--middle">
                    <h3 class="kt-login__title">Ankara Üniversitesi Mezun Bilgi Sistemine Hoşgeldiniz</h3>
                    <h4 class="kt-login__subtitle">
                        Mezun Bilgi Sistemi, mezunlarımız ile üniversitemiz arasındaki bağı koparmamak için ve iletişimi korumaya
                        yönelik oluşturulmuş bir interaktif iletişim aracıdır ve katılım tamamen ücretsizdir.
                    </h4>

                    <h3 class="kt-login__subtitle">
                        Sisteme kayıt olmaya başlamadan önce
                        <a
                            style="color: #fff; font-weight: bold; font-variant-position: normal"
                            href="https://www.turkiye.gov.tr/yuksekogretim-mezun-belgesi-sorgulama"
                            target="_blank"
                            >E-Devlet Mezun Belgesi Sorgulama</a
                        >
                        hizmeti üzerinden mezuniyet bilginizi kontrol etmelisiniz.<br />Eğer bu hizmet aracılığı ile
                        mezuniyetinizi görüntüleyemiyorsanız mezun olduğunuz birim öğrenci işlerine başvurarak mezun bilginizi
                        güncelletmeniz gerekmektedir.
                        <a
                            style="color: #fff; font-weight: bold; font-variant-position: normal"
                            href="https://oidb.ankara.edu.tr/2017/05/11/maliye-bakanligi-muhasebat-genel-mudurlugu-9-personel-odemeleri-ile-ilgili-2017-9-sayili-kbs-duyurusu-ile-ilgili-olarak-mezun-ogrencilerin-yoksise-aktarilmasi-hakkinda/"
                            target="_blank"
                        >
                            Oidb Bilgilendirme Sayfası
                        </a>
                    </h3>
                    <h4 class="kt-login__subtitle">
                        <span class="kt-login__signup-label">Henüz bir hesabınız yok mu?</span>&nbsp;&nbsp;
                        <a
                            style="color: #fff; font-weight: bold; font-variant-position: normal"
                            href="javascript:;"
                            routerLink="/auth/register"
                            class="kt-link kt-login__signup-link"
                            >{{ 'AUTH.GENERAL.SIGNUP_BUTTON' | translate }}</a
                        >
                    </h4>
                    <h4 class="kt-login__subtitle" style="margin-bottom: 10px !important">
                        Detaylı bilgi için:
                        <a
                            target="_blank"
                            style="color: #fff; font-weight: bold; font-variant-position: normal"
                            href="http://mezunlar.ankara.edu.tr/"
                            >Ankara Üniversitesi Mezunları</a
                        >
                    </h4>
                    <h4 class="kt-login__subtitle" style="margin-top: 1px !important">
                        İletişim:
                        <a
                            target="_blank"
                            style="color: #fff; font-weight: bold; font-variant-position: normal"
                            href="http://karmer.ankara.edu.tr/konum"
                            >Ankara Üniversitesi Kariyer Merkezi</a
                        >
                    </h4>
                </div>
            </div>
            <div class="kt-grid__item">
                <div class="kt-login__info">
                    <div class="kt-login__copyright">
                        © {{ today | date : 'yyyy' }} Ankara Üniversitesi Bilgi İşlem Daire Başkanlığı Yazılım Geliştirme Ekibi
                    </div>
                    <div class="kt-login__menu">
                        <!-- <a href="javascript:;" class="kt-link">Privacy</a>
                        <a href="javascript:;" class="kt-link">Legal</a>
                        <a href="javascript:;" class="kt-link">Contact</a> -->
                    </div>
                </div>
            </div>
        </div>
        <!--begin::Aside-->

        <!--begin::Content-->
        <div class="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper">
            <router-outlet></router-outlet>
        </div>
        <!--end::Content-->
    </div>
</div>
